import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { LoaderService } from '@app/services/loader.service';
import { PageShellComponent } from '../../_components/page-shell/page-shell.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PageShellComponent]
})
export class DashboardComponent {
  private readonly loaderService = inject(LoaderService);

  constructor() {
    this.loaderService.showNavbarSubject.next(true);
  }
}
